let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("jV8xH")).then(() => parcelRequire('hBjVA'));